import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import config from './config';
import './styles/globals.css';

document.title = config.appName;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
